import { createEffect, createEvent, createStore, sample } from 'effector';
import { labmateClient, wsClient } from '@shared/configs/socket-client';
import { devicesEntity } from '@entities/devices';
import { delay } from 'patronum';
import { sleep } from '@shared/lib/sleep';

const searchDevices = createEvent();
const connectToDevice = createEvent<{ address: string; name: string }>();
const disconnectFromDevice = createEvent<string>();
const disconnectCurrentDevice = createEvent();

const searchDevicesFx = createEffect(async () => {
  labmateClient.getBluetoothDevicesFx();

  wsClient.emit({
    action: 'scan_bluetooth',
    data: {},
  });

  await sleep(3000);
});

sample({
  clock: searchDevices,
  target: searchDevicesFx,
});

sample({
  source: devicesEntity.$connectedDevice,
  clock: disconnectCurrentDevice,
  filter: Boolean,
  fn: (device) => device.deviceName,
  target: disconnectFromDevice,
});

const $connectPending = createStore(false);

$connectPending
  .on(connectToDevice, () => true)
  .reset([
    delay(connectToDevice, 6000),
  ])

export const bluetoothConnectModel = {
  searchDevices,
  connectToDevice,
  disconnectFromDevice,
  disconnectCurrentDevice,
  $searchPending: searchDevicesFx.pending,
  $connectPending,
};

